import { useEffect, useState } from 'react';

const STORAGE_KEY = 'erp:overview:advancedMode';

export const useErpAdvancedMode = () => {
  const [advancedMode, setAdvancedMode] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored !== null ? stored === 'true' : false;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === STORAGE_KEY && event.newValue !== null) {
        setAdvancedMode(event.newValue === 'true');
      }
    };

    const handleCustomEvent = () => {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored !== null) {
        setAdvancedMode(stored === 'true');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('erp:advancedModeChanged', handleCustomEvent);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('erp:advancedModeChanged', handleCustomEvent);
    };
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(STORAGE_KEY, String(advancedMode));
    window.dispatchEvent(new Event('erp:advancedModeChanged'));
  }, [advancedMode]);

  return { advancedMode, setAdvancedMode } as const;
};

export default useErpAdvancedMode;
